import React from "react";
import styles from "./ErrorBar.module.css";

interface ErrorBarProps {
  show?: boolean;
  children: React.ReactNode;
}
/** A fixed position top bar for error alerts. */
export const ErrorBar: React.FC<ErrorBarProps> = ({
  children,
  show,
}: ErrorBarProps) => {
  return (
    <div
      className={`${styles["error-bar"]} ${
        show ? styles["show"] : styles["hide"]
      }`}
    >
      {children}
    </div>
  );
};
